import Vue from 'vue'
import Router from 'vue-router'
// import { Toast } from 'vant'
// import { loading } from '@/common/loading';

Vue.use(Router)

//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRoutes = []
//异步挂载的路由
//动态需要根据权限加载的路由表
export const asyncRoutes = [
  {
    path: '/loginOld',
    name: 'loginOld',
    component: () => import('../views/loginOld/loginOld.vue'),
    hidden: true,
    meta: {
      title: '登录页面',
      // keepAlive: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue'),
    hidden: true,
    meta: {
      title: '登录页面',
      // keepAlive: true
    }
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('../views/error/error.vue'),
    hidden: true,
    meta: {
      title: '错误',
      // keepAlive: true
    }
  },
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index/index.vue'),
    hidden: true,
    meta: {
      title: '首页',
      // keepAlive: true  //需要被缓存，页面不刷新
    },
    children: []
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home/home.vue'),
    hidden: true,
    meta: {
      title: '欢迎页',
      // keepAlive: true  //需要被缓存，页面不刷新
    }
  },
  {
    path: '/caijixiangqingTB',
    name: 'caijixiangqingTB',
    hidden: true,
    component: () => import('../views/jiagecaijiTB/component/caijixiangqing.vue'),
    meta: {
      title: '价格填报详情',
    }
  },
  {
    path: '/caijixiangqingNew',
    name: 'caijixiangqingNew',
    hidden: true,
    component: () => import('../views/jiagecaijiNew/component/caijixiangqingNew.vue'),
    meta: {
      title: '价格采集详情',
    }
  },
  {
    path: '/caijixiangqingLessNew',
    name: 'caijixiangqingLessNew',
    hidden: true,
    component: () => import('../views/jiagecaijiNew/component/caijixiangqingLessNew.vue'),
    meta: {
      title: '价格采集详情',
    }
  },
  {
    path: '/qxtbxiangqing',
    name: 'qxtbxiangqing',
    component: () => import('../views/qxtbcaiji/component/qxtbxiangqing.vue'),
    hidden: true,
    meta: {
      title: '填报审核详情',
    }
  },
  {
    path: '/qxtbxiangqingLess',
    name: 'qxtbxiangqingLess',
    component: () => import('../views/qxtbcaiji/component/qxtbxiangqingLess.vue'),
    hidden: true,
    meta: {
      title: '填报审核详情',
    }
  },
    {
    path: '/qxtbxiangqingNew',
    name: 'qxtbxiangqingNew',
    component: () => import('../views/xmtbcaiji/component/qxtbxiangqing.vue'),
    hidden: true,
    meta: {
      title: '填报审核详情',
    }
  },
  {
    path: '/qxtbxiangqingLessNew',
    name: 'qxtbxiangqingLessNew',
    component: () => import('../views/xmtbcaiji/component/qxtbxiangqingLess.vue'),
    hidden: true,
    meta: {
      title: '填报审核详情',
    }
  },
  {
    path: '/tianbaoxiangqing',
    name: 'tianbaoxiangqing',
    component: () => import('../views/agentFill/component/tianbaoxiangqing.vue'),
    hidden: true,
    meta: {
      title: '市级代填报详情',
    }
  },
  {
    path: '/tianbaoxiangqingLess',
    name: 'tianbaoxiangqingLess',
    component: () => import('../views/agentFill/component/tianbaoxiangqingLess.vue'),
    hidden: true,
    meta: {
      title: '市级代填报详情',
    }
  },
  {
    path: '/jiageshenheNew',
    name: 'jiageshenheNew',
    component: () => import('../views/jiageshenheListNew/component/jiageshenheNew.vue'),
    hidden: true,
    meta: {
      title: '价格审核详情',
    }
  },
  {
    path: '/jiageshenheLessNew',
    name: 'jiageshenheLessNew',
    component: () => import('../views/jiageshenheListNew/component/jiageshenheLessNew.vue'),
    hidden: true,
    meta: {
      title: '价格审核详情',
    }
  },
  {
    path: '/junjiashenheNew',
    name: 'junjiashenheNew',
    component: () => import('../views/junjiashenheList/component/junjiashenheNew.vue'),
    hidden: true,
    meta: {
      title: '均价审核',
    }
  },
   {
    path: '/junjiaxiangqing',
    name: 'junjiaxiangqing',
    component: () => import('../views/junjiashenheList/component/junjiaxiangqing.vue'),
    hidden: true,
    meta: {
      title: '均价审核详情',
    }
  },
  {
    path: '/marketInspectionModify',
    name: 'marketInspectionModify',
    component: () => import('../views/marketInspection/modify.vue'),
    hidden: true,
    meta: {
      title: '市场巡查-操作',
      // keepAlive: true
    },
  },
  {
    path: '/shengjiAgenFillLessNew',
    name: 'shengjiAgenFillLessNew',
    component: () => import('../views/shengjiAgenFill/component/shengjiLessNew.vue'),
    hidden: true,
    meta: {
      title: '自治区代填报-详情',
      // keepAlive: true
    },
  },
  {
    path: '/shengjiAgenFillNew',
    name: 'shengjiAgenFillNew',
    component: () => import('../views/shengjiAgenFill/component/shengjiNew.vue'),
    hidden: true,
    meta: {
      title: '自治区代填报-详情',
      // keepAlive: true
    },
  },
  {
    path: '/cityReportxiangqing',
    name: 'cityReportxiangqing',
    component: () => import('../views/cityReport/component/cityReportxiangqing.vue'),
    hidden: true,
    meta: {
      title: '国家上报详情',
    }
  },
  {
    path: '/complaintSuggestion',
    name: 'complaintSuggestion',
    component: () => import('../views/complaintSuggestion/index.vue'),
    meta: {
      title: '投诉与建议'
      // keepAlive: true
    }
  },
  {
    path: '/tongzhixiangqing',
    name: 'tongzhixiangqing',
    component: () => import('../views/tongzhigonggao/component/tongzhixiangqing.vue'),
    meta: {
      title: '通知公告详情'
      // keepAlive: true
    }
  },
  {
    path: '/Fill',
    name: 'Fill',
    component: () => import('../views/questionnaireFilling/component/Fill.vue'),
    meta: {
      title: '问卷填报'
      // keepAlive: true
    }
  },
  {
    path: '/queryFile',
    name: 'queryFile',
    component: () => import('../views/queryFile/index.vue'),
    meta: {
      title: '预览文件'
      // keepAlive: true
    }
  },
]


export const createRouter = () =>
  new Router({
    mode: "hash", // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: asyncRoutes
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
// 路由前置导航守卫
router.beforeEach((to, from, next) => {
  // 根据路由元信息设置文档标题
  window.document.title = to.meta.title ? to.meta.title : '价格监测APP'
  next()
  /* const role=localStorage.getItem("ifShowleaderCheck");
   const ifTrue=to.meta.roleCheck==role;

   console.log(role)
   console.log(to.meta.roleCheck)
   console.log(ifTrue)

   if (ifTrue==true && to.meta.roleCheck!=undefined) {
      /!* this.$dialog.alert({
           message: '该用户无此功能权限!'
       })*!/
       //Toast( '当前用户无此功能权限!');
       this.$dialog.alert({
           message: '当前用户无此功能权限!'
       })
       loading(false)
       return;
   } else {
       next()
   }*/
})

export default router
